import React from "react";
import { useTranslation } from "react-i18next";
import AppConfig from "util/AppConfig";
import ObjectUtils from "util/ObjectUtils";
import { Input } from "components/bootstrap";
import { Select, TimeUnitInput } from "components/common";
const MaxmindAdapterFieldSet = ({
  config,
  updateConfig,
  handleFormEvent,
  validationState,
  validationMessage
}) => {
  const { t } = useTranslation("common");
  const isCloud = AppConfig.isCloud();
  const pathsForCloud = {
    IPINFO_STANDARD_LOCATION: "/etc/graylog/server/standard_location.mmdb",
    IPINFO_ASN: "/etc/graylog/server/asn.mmdb"
  };
  const ipInfoDatabaseTypes = [
    { label: t("maxmind_adapter.database_types.ipinfo_location"), value: "IPINFO_STANDARD_LOCATION" },
    { label: t("maxmind_adapter.database_types.ipinfo_asn"), value: "IPINFO_ASN" }
  ];
  let databaseTypes = [
    { label: t("maxmind_adapter.database_types.asn"), value: "MAXMIND_ASN" },
    { label: t("maxmind_adapter.database_types.city"), value: "MAXMIND_CITY" },
    { label: t("maxmind_adapter.database_types.country"), value: "MAXMIND_COUNTRY" }
  ];
  if (isCloud) {
    databaseTypes = ipInfoDatabaseTypes;
  } else {
    databaseTypes = databaseTypes.concat(ipInfoDatabaseTypes);
  }
  const update = (value, unit, enabled, name) => {
    const newConfig = ObjectUtils.clone(config);
    newConfig[name] = enabled ? value : 0;
    newConfig[`${name}_unit`] = unit;
    updateConfig(newConfig);
  };
  const updateCheckInterval = (value, unit, enabled) => {
    update(value, unit, enabled, "check_interval");
  };
  const onDbTypeSelect = (id) => {
    const newConfig = ObjectUtils.clone(config);
    if (isCloud) {
      newConfig.path = pathsForCloud[id];
    }
    newConfig.database_type = id;
    updateConfig(newConfig);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, !isCloud && /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "path",
      name: "path",
      label: t("maxmind_adapter.field_set.file_path"),
      autoFocus: true,
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("path", t("maxmind_adapter.field_set.file_path_help")),
      bsStyle: validationState("path"),
      value: config.path,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "database-type-select",
      label: t("maxmind_adapter.field_set.database_type"),
      required: true,
      autoFocus: true,
      help: t("maxmind_adapter.field_set.database_type_help"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: t("maxmind_adapter.field_set.database_type_placeholder"),
        clearable: false,
        options: databaseTypes,
        onChange: onDbTypeSelect,
        value: config.database_type
      }
    )
  ), /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: t("maxmind_adapter.field_set.refresh_file"),
      help: t("maxmind_adapter.field_set.refresh_file_help"),
      update: updateCheckInterval,
      value: config.check_interval,
      unit: config.check_interval_unit || "MINUTES",
      defaultEnabled: config.check_interval > 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default MaxmindAdapterFieldSet;
